<template lang="pug">
div
  v-menu(v-model="show" rounded="lg" allow-overflow :close-on-content-click="false" offset-y content-class="border-menu" max-height="250")
    template(#activator="{ on, attrs }")
      v-sheet.text-md.round-xl.border-menu(v-bind="attrs" v-on="on" flat outlined :height="height" min-width="240")
        .d-flex.align-center.fill-height.text-sm.px-3
          .flex-grow-1.text-left(v-if="value") {{ showValue(value) }}
          .flex-grow-1.neutral500--text.text-left(v-else) Enter patient name, NRIC or phone number
          v-icon(size="20") $yzi-chevron-down
    .text-xs.white
      .search-input
        v-text-field.mb-2.mx-4.text-sm.round-xl(v-model="searchPatient" outlined placeholder="Enter patient name, NRIC or phone number" autofocus dense hide-details clearable)
        v-divider
      .d-flex.align-center.px-4.py-3
        .font-semibold Existing patient
        y-pagination(v-model="page" :pageSize="fetchCount" :count="count" :loading="isFetching")
      v-divider
      div.d-flex.justify-center(v-if="isFetching")
        v-progress-linear(:width="3" rounded color="primary" indeterminate)
      div(v-for="item in patients")
        div.px-4.py-2(v-if="isItemDisabled(item)" style="width: 100%; background-color: var(--v-neutral300)")
          .text-sm.neutral700--text {{ item.name }}
          v-row.mt-1(no-gutters)
            v-col(cols="4")
              div.d-flex.align-center
                v-icon(size="15" color="var(-v-neutral500)") $yzi-user-03
                .text-xs.neutral500--text.ml-1 {{ item.ic }}
            v-col
              div.d-flex.align-center
                v-icon(size="15" color="var(-v-neutral500)") $yzi-phone
                .text-xs.neutral500--text.ml-1 +{{ item.phone }}
          y-chip.text-xs.mt-2.danger700--text.danger200(size="xs") {{ getDisabledReason(item) }}
        div.px-4.py-2.clickable.hover-selection(v-else style="width: 100%;" @click="selectItem(item)")
          .text-sm.neutral700--text {{ item.name }}
          v-row.mt-1(no-gutters)
            v-col(cols="4")
              div.d-flex.align-center
                v-icon(size="15" color="var(-v-neutral500)") $yzi-user-03
                .text-xs.neutral500--text.ml-1 {{ item.ic }}
            v-col
              div.d-flex.align-center
                v-icon(size="15" color="var(-v-neutral500)") $yzi-phone
                .text-xs.neutral500--text.ml-1 +{{ item.phone }}
        v-divider
      template(v-if="!patients.length")
        .pa-4
          .py-3 No results match
          y-button(label="Add new patient" prepend-icon="$yzi-user-plus-01" outlined block @click="addNewPatient" size="sm")
  
  .dialogs
    add-patient(v-if="showAddPatientDialog" :open.sync="showAddPatientDialog")

</template>

<script>
import { mapGetters, mapActions } from 'vuex'
import { debounce } from '@/utils'
import AddPatient from '@/components/clinic/patient/AddPatient.vue'

export default {
  components: {
    AddPatient,
  },
  props: {
    value: null,
    disabledItems: {
      type: Array,
      default: () => {
        return []
      }
    },
    fields: {
      type: Array,
      default: () => {
        return []
      }
    },
    expandFields: {
      type: Array,
      default: () => {
        return []
      }
    },
    height: {
      default: 48
    }
  },
  data: () => ({
    searchPatient: null,
    show: false,
    isFetching: false,
    isLoading: false,
    page: 1,
    fetchCount: 20,
    count: 0,
    patients: [],
    showAddPatientDialog: false,
    defaultFields: ['id', 'name', 'phone', 'ic'],
  }),
  watch: {
    show (val) {
      if (val) {
        this.fetchPatients(this.searchPatient)
      } else {
        if (this.value) {
          this.searchPatient = typeof this.value === 'object' ? this.value.name : this.value
        }
        this.$emit('change')
      }
    },
    page () {
      this.fetchPatients(this.searchPatient)
    },
    searchPatient () {
      this.searchStart()
    }
  },
  computed: {
    ...mapGetters({
      company: 'getCompany',
      systemProviders: 'clinic/getSystemProviders',
      hqSelectedCompany: 'hq/getSelectedCompany',
      isHq: 'hq/getIsHq'
    }),
    fieldsParam () {
      const _fields = [...new Set([...this.defaultFields, ...this.fields])]
      return _fields.join(',')
    },
    expandFieldsParam () {
      if (this.expandFields.length === 0) {
        return null
      }
      return this.expandFields.join(',')
    }
  },
  methods: {
    ...mapActions(['showMessage']),
    fetchPatients (val) {
      this.isFetching = true
      let params = {
        fields: this.fieldsParam,
        expand: this.expandFieldsParam,
        search: val || '',
        page: this.page
      }
      if (!val) {
        params.ordering = '-created'
      }
      const endpoint = this.isHq ? `/clinics/${this.hqSelectedCompany.slug}/patients` : `/clinics/${this.company.slug}/patients`
      this.$axios.get(endpoint, { params })
        .then(resp => {
          this.patients = resp.data.results
          this.count = resp.data.count
        })
        .catch(() => {})
        .finally(() => {
          this.isFetching = false
        })
    },
    searchStart: debounce(function () {
      this.page = 1
      this.fetchPatients(this.searchPatient)
    }, 750),
    selectItem (item) {
      this.$emit('input', item)
      this.show = false
    },
    showValue (val) {
      if (typeof val === 'object') {
        return val.name
      } else {
        return val
      }
    },
    isItemDisabled (item) {
      return this.disabledItems.find(disabledItem => disabledItem.id === item.id)
    },
    getDisabledReason (item) {
      const found = this.disabledItems.find(disabledItem => disabledItem.id === item.id)
      if (found) {
        return found.reason
      }
    },
    addNewNric () {
      this.$emit('input', this.searchPatient)
      this.show = false
    },
    addNewPatient () {
      this.showAddPatientDialog = true
      this.show = false
      this.searchPatient = null
    }
  }
}
</script>

<style scoped>
.border-menu {
  border: 1px solid var(--v-basic500);
  box-shadow: none;
}
.search-input {
  position: sticky;
  top: 0px;
  background-color: #FFFFFF !important;
  border-color: #FFFFFF !important;
  z-index: 4;
  padding-top: 8px;
}
.hover-selection:hover {
  cursor: pointer;
  background-color: var(--v-infoT08) !important;
}
</style>